import { IBackgroundJobStatistics } from '../../ts/ServerApi/types/IBackgroundJobStatistics';
import { IGetItemsParams } from '../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../ts/ServerApi/types/IGetItemsResult';
import { Request } from '../../httpClient/serverApi/requests/Request';

export interface IGetBackgroundJobStatisticsResult extends IGetItemsResult, IBackgroundJobStatistics {}

export class GetBackgroundJobStatisticsRequest extends Request<IGetItemsParams, IGetBackgroundJobStatisticsResult> {
  constructor(params: IGetItemsParams) {
    super('getBackgroundJobStatistics', params);
  }
}
